<template>
	<div>
		<v-container id="details">
			<v-row no-gutters>
				<v-col cols="12" class="mb-2">
					<div class="text-h5 text-center">COUPON</div>
				</v-col>
				<v-col cols="6">
					<img :src="barcode" />
					<div class="text-h6 font-weight-bold" style="color: black"># {{ coupon }}</div>
				</v-col>
				<v-col cols="6">
					<div class="text-right">
						<v-img v-if="getSettings.logo != ''" :src="getSettings.logo" />
						<strong>{{ getSettings.name }}</strong
						><br />
						{{ getSettings.InvoiceAddress?.Company }}<br />
						{{ getSettings.InvoiceAddress?.Address }}<br />
						{{ getSettings.InvoiceAddress?.City }}, {{ getSettings.InvoiceAddress?.Cap }} - {{ getSettings.InvoiceAddress?.Country }}<br />
						VAT: {{ getSettings.InvoiceAddress?.Vat }}<br />
						<template v-if="getSettings.InvoiceAddress?.Vat != getSettings.InvoiceAddress?.Fiscalcode">CF: {{ getSettings.InvoiceAddress?.Fiscalcode }} <br /></template>
						<span>{{ getSettings.ShippingAddress?.Phone }}</span>
					</div>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="12" class="mb-5">
					<div class="help">
						<b>{{ oggetto }}</b>
					</div>
					<p><span v-html="messaggio"></span></p>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
	name: 'PrintReceipt',
	data() {
		return {
			barcode: '',
			order: {},
			totals: {
				products: 0.0,
				subtotal: 0.0,
				tax: 0.0,
			},
			messaggio: '',
			oggetto: '',
			coupon: '',
		};
	},
	async created() {
		document.querySelector('#app > div.v-application--wrap > header').style.display = 'none';
		await this.getData();
		const fetchItem = await this.fetchCoupon(this.$route.params);

		this.oggetto = fetchItem?.oggetto;
		this.messaggio = fetchItem?.message;
		this.barcode = await this.createBarcodeOrder({ _id: fetchItem?.data?._id, name: fetchItem?.data?.code });
		this.coupon = fetchItem?.data?.code;
		await this.print();
	},

	computed: {
		...mapGetters({
			getSettings: 'settings/getSetting',
			getProfile: 'profile/getId',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			editItem: 'orders/edit',
			fetchCoupon: 'couponcode/asyncDetailData',
			getData: 'profile/getProfile',
			createBarcodeOrder: 'barcode/createBarcodeOrder',
		}),
		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},

		async print() {
			setTimeout(() => {
				window.print();
			}, 1500);
		},
	},
};
</script>

<style scoped></style>
